import React, { useEffect, useRef } from 'react';
import * as echarts from 'echarts/core';
import { ToolboxComponent, LegendComponent, TooltipComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { LabelLayout } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import NoDataFound from '../../NoDataFound';

echarts.use([
  ToolboxComponent,
  LegendComponent,
  TooltipComponent,
  PieChart,
  CanvasRenderer,
  LabelLayout
]);

const InstituteProgramChart = ({ data }) => {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  // Check if data is null, undefined, or empty array
  const isDataEmpty = !data || data.length === 0;

  useEffect(() => {
    if (chartRef.current && !isDataEmpty) {
      if (!chartInstance.current) {
        chartInstance.current = echarts.init(chartRef.current);
      }

      const option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}: {c}',
          confine: true
          // position: ['0%', '50%']
        },
        series: [
          {
            name: 'Programs',
            type: 'pie',
            radius: ['20%', '70%'],
            center: ['50%', '50%'],
            roseType: 'area',
            itemStyle: {
              borderRadius: 8
            },
            label: {
              formatter: '{b}: {d}%'
            },
            emphasis: {
              label: {
                show: true,
                fontSize: 14,
                fontWeight: 'bold',
                formatter: '{b}: {c}'
              }
            },
            data: data.map(item => ({
              value: item.value,
              name: item.name
            }))
          }
        ]
      };

      chartInstance.current.setOption(option);
    }

    return () => {
      if (chartInstance.current) {
        chartInstance.current.dispose();
        chartInstance.current = null;
      }
    };
  }, [data, isDataEmpty]);

  // Show "Data not available" message when data is empty
  if (isDataEmpty) {
    return (
     <NoDataFound message='Data not available' height='100%'/>
    );
  }

  return (
    <div 
      ref={chartRef} 
      style={{ 
        width: '100%', 
        height: window.innerWidth <= 768 ? '200px' : '350px'
      }} 
    />
  );
};

export default InstituteProgramChart;